module.exports = __webpack_public_path__ + "static/media/Surgeon.245c08b9.svg";